import React, { Component } from "react";
import style from "./profileNavBarTabs.module.scss";
import { inject, observer } from "mobx-react";
import ProfileNavBarTab from "../profileNavBarTab/profileNavBarTab";
import UiStore from "../../stores/UiStore";
import FundraisingStore from "../../stores/FundraisingStore";
import AuthStore from "../../stores/AuthStore";

@inject("uiStore")
@inject("fundraisingStore")
@inject("authStore")
@observer
class ProfileTabs extends Component {
  props: {
    uiStore?: UiStore;
    fundraisingStore?: FundraisingStore;
    authStore?: AuthStore;
    countEligibleAchievements: number
  };

  constructor(props) {
    super(props);
  }

  render() {

    return (
      <div className={style.profileNav}>
        <div className={style.profileNavUnder}>
          <ProfileNavBarTab
            label="Профиль"
            disabled={false}
            isActive={this.props.uiStore.activeTab == 0}
            link={"/profile"}
            index={0}
          />
          <ProfileNavBarTab
            label="Донации"
            disabled={false}
            isActive={this.props.uiStore.activeTab == 6}
            link={"/profile/donations"}
            index={6}
          />
          <ProfileNavBarTab
            label="Достижения"
            disabled={false}
            isActive={this.props.uiStore.activeTab == 5}
            link={"/profile/achievements"}
            index={5}
            notification={this.props.countEligibleAchievements}
          />
          <ProfileNavBarTab
            label="События"
            disabled={false}
            isActive={this.props.uiStore.activeTab == 3}
            link={"/profile/fundraising"}
            index={3}
          />
          <ProfileNavBarTab
            label="Вклад"
            disabled={false}
            isActive={this.props.uiStore.activeTab == 4}
            link={"/profile/impact"}
            index={4}
          />
          <ProfileNavBarTab
            label="Бонусы"
            disabled={false}
            isActive={this.props.uiStore.activeTab == 1}
            link={"/profile/bonus"}
            index={1}
          />
          <ProfileNavBarTab
            label="Настройки"
            disabled={false}
            isActive={this.props.uiStore.activeTab == 2}
            link={"/profile/settings/personal"}
            index={2}
          />
        </div>
      </div>
    );
  }
}

export default ProfileTabs;
